import { UpdateTransferMealInput } from '../../lib/types/models/transfer-meal/create-transfer-meal'
import { TransferMealOrder } from '../../lib/types/models/transfer-meal/transfer-meal'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTransferMealOrder(id: number) {
  return restApiClient
    .url(constructApiUrl(API.transferMeal.getOrder.url, { id }))
    .get<TransferMealOrder>()
}

export function updateTransferMealOrder(data: IdInput<UpdateTransferMealInput>) {
  const { id, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API.transferMeal.updateOrder.url, { id }))
    .patch<{ message: string }, UpdateTransferMealInput>(rest)
}

export function cancelTransferMealOrder(id: number) {
  return restApiClient
    .url(constructApiUrl(API.transferMeal.cancelOrder.url, { id }))
    .post<{ message: string }>()
}

export function resendTransferMealOrder(id: number) {
  return restApiClient
    .url(constructApiUrl(API.transferMeal.resendOrder.url, { id }))
    .post<{ message: string }>()
}
